'use client';

import { PageSectionsLandingHeroConversionForm } from '@/tina/__generated__/types';
import { layout } from '../../styles/layout';
import * as stylex from '@stylexjs/stylex';
import '../../styles/tokens.stylex';
import { color, columnWidth, shadow, spacing } from '../../styles/tokens.stylex';
import { resetTypographyColors } from '../../styles/themes';
import { typography } from '../../styles/typography';
import { Button } from '../Buttons';
import { Marquee } from '../Marquee';
import { Form } from '../Form/Fields/primitive/Form';
import { motion } from 'motion/react';
import { SubmitEvent, useEffect, useState } from 'react';
export type ConversionFormPreviewMode = 'default' | 'minimised';
type ConversionFormProps = {
  data: PageSectionsLandingHeroConversionForm;
  previewMode?: ConversionFormPreviewMode;
  onSubmit: (e: SubmitEvent<HTMLFormElement>) => void;
  onPrefetch?: () => void;
  children: React.ReactNode;
  previewFormRef: React.RefObject<HTMLDivElement | null>;
};
export function ConversionFormPreview({
  data,
  previewMode = 'default',
  onSubmit,
  onPrefetch,
  children,
  previewFormRef
}: ConversionFormProps) {
  // const [scrollYState, setScrollYState] = useState(0)
  // useEffect(() => {
  //   const onScroll = () => setScrollYState(window.scrollY)
  //   window.addEventListener('scroll', onScroll, { passive: true })
  //   return () => window.removeEventListener('scroll', onScroll)
  // }, [])
  const heading = data?.headingOverride || data.form?.heading;
  const subheading = data?.subheadingOverride || data.form?.subheading;
  const cta = data?.ctaOverride || data.form?.callToAction;
  return <motion.div layoutId="conversion-form-canvas"
  //layoutDependency={`${scrollYState}-${previewMode}`}
  {...stylex.props(resetTypographyColors, layout.contentCard, sx.card, previewMode === 'minimised' && sx.cardMinimised)} transition={{
    type: 'spring',
    stiffness: 500,
    damping: 30,
    mass: 0.5
  }}>
      <motion.div layoutId="conversion-form-heading-wrapper" {...{
      0: {
        className: "x3ybb33 xrvj5dj"
      },
      1: {
        className: "x3ybb33 x15264ok"
      }
    }[!!(previewMode === 'minimised') << 0]} transition={{
      type: 'spring',
      stiffness: 500,
      damping: 30,
      mass: 0.5
    }}>
        <motion.h1 layoutId="conversion-form-heading" {...stylex.props([typography.heading2, sx.heading, previewMode === 'minimised' && typography.heading3])} transition={{
        type: 'spring',
        stiffness: 500,
        damping: 30,
        mass: 0.5
      }}>
          {heading}
        </motion.h1>
        <motion.p layoutId="conversion-form-subheading" {...stylex.props([typography.body, previewMode === 'minimised' && sx.minimised])} transition={{
        type: 'spring',
        stiffness: 500,
        damping: 30,
        mass: 0.5
      }}>
          {subheading}
        </motion.p>
      </motion.div>
      <Form.Root onSubmit={onSubmit} render={<motion.form layout />}>
        <Form.Section ref={previewFormRef} styles={[previewMode !== 'minimised' && sx.section, previewMode === 'minimised' && sx.minimised]} render={<motion.div layout transition={{
        type: 'spring',
        stiffness: 500,
        damping: 30,
        mass: 0.5
      }} />}>
          {children}
        </Form.Section>
        <motion.div layout {...{
        0: {
          className: "xrvj5dj x1hfb3d2"
        },
        1: {
          className: "xrvj5dj xdj266r"
        }
      }[!!(previewMode === 'minimised') << 0]} transition={{
        type: 'spring',
        stiffness: 500,
        damping: 30,
        mass: 0.5
      }}>
          <Button type="submit" secondaryText={cta?.secondaryLabel} onMouseEnter={onPrefetch} onFocus={onPrefetch}>
            {cta?.label ?? 'Get My Quote'}
          </Button>
        </motion.div>
      </Form.Root>
      <div {...{
      0: {
        className: "xdzeex0 xyi9k72 x1pjf0gv"
      },
      1: {
        className: "xdzeex0 xyi9k72"
      }
    }[!!(previewMode === 'minimised') << 0]}>
        <Marquee data={cta?.benefits?.map(benefit => ({
        text: benefit?.benefit ?? '',
        icon: benefit?.icon ?? ''
      }))} />
      </div>
    </motion.div>;
}
const sx = {
  card: {
    kOIVth: "x10f5beq x5h8yh3",
    kkqhue: "xfb7e1 x17bpcie",
    kUOVxO: "xvueqy4",
    kWkggS: "x19i6xfm x96cjap",
    kGVxlE: "x1xt9a6s",
    k1xSpc: "xrvj5dj",
    kHBbk8: "xc8icb0",
    kVAEAm: "x1n2onr6 x1ns7oz0",
    kY2c9j: "xhtitgo",
    krVfgx: "xdmrair x7jmekp",
    ks0D6T: "x1thhexh x1uw9m2y",
    kzqmXN: "x1uw578s",
    $$css: true
  },
  section: {
    kmkexE: "x6atunx",
    k1xSpc: "x1s85apg x1oectc0",
    kSiTet: "x4itv7f x1hc1fzr",
    $$css: true
  },
  minimised: {
    k1xSpc: "x1s85apg",
    $$css: true
  },
  cardMinimised: {
    kOIVth: "x3ybb33",
    kt4wiu: "xji1adu",
    kVAEAm: "xixxii4",
    k87sOh: "x80663w x1b6xndq",
    $$css: true
  },
  heading: {
    kVAEAm: "x1n2onr6",
    $$css: true
  }
};